"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgRobotFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M8.77 20.23a26.84 26.84 0 017.21-1c.72 0 1.41 0 2.08.09l-6.26-8.81 7-2.35a7.09 7.09 0 001.83 3.56l.37.35L27.16 11l-.35-2-5.06.9a4.93 4.93 0 01-1-2.92 5 5 0 011-2.92l5.06.9.35-2L21 1.93l-.37.35a7 7 0 00-1.83 3.79l-8.34 2.78a3.83 3.83 0 00-4.78-.25 4.06 4.06 0 00-1 5.55zM27.53 24.16A22.87 22.87 0 0016 21.25a22.85 22.85 0 00-11.56 2.91l-.44.29V28h24v-3.55z" })));
}
exports.default = SvgRobotFilled;
//# sourceMappingURL=RobotFilled.js.map